import ORMfunctions from "../../hooks/app/general";
import GMaps from "../maps/gmaps";

const slug = ORMfunctions.slugMe;

const cookiefound = { maps: false };
if (process.env.REACT_APP_COOKIECONSENTCOOKIEMAPSNAME) {
  cookiefound.maps = ORMfunctions.checkcookie(
    process.env.REACT_APP_COOKIECONSENTCOOKIEMAPSNAME,
  );
}

function StationDetail(props: any) {
  const station = props.station;
  const showmap = false;
  let map;
  if (cookiefound.maps && showmap) {
    if (station.latitude) {
      map = (
        <div className="orm-map">
          <GMaps coords={{ lat: station.latitude, lng: station.longitude }} />
        </div>
      );
    } else {
      map = <div className="orm-map" style={{ height: "300px" }}></div>;
    }
  }

  if (props.type === "standard") {
    return (
      <div className="orm-row">
        <div className="orm-col-xs-12">
          <div className="orm-stationsfilter-station-list-station">
            <div className="orm-row">
              {(props.showdetails === "all" ||
                props.showdetails === "location") && (
                <div className="orm-col-xs-12 orm-flex justify-space-between">
                  {props.detailpage === "true" ? (
                    <a
                      className="orm-textlink"
                      href={
                        ORMfunctions.baseLang() +
                        `/station/` +
                        slug(station.name)
                      }
                    >
                      <h1 className="orm-headline__h3 orm-mb-8">
                        {station.name}
                      </h1>
                    </a>
                  ) : (
                    <h1 className="orm-headline__h3 orm-mb-8">
                      {station.name}
                    </h1>
                  )}
                  {station.distance ? (
                    <div className="orm-station__distance orm-station__distance--stationlist">
                      <i className="fas fa-map-marker-alt"></i>{" "}
                      {station.distance} km
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {(props.showdetails === "all" ||
                props.showdetails === "location") && (
                <div
                  className={`orm-col-xs-12 orm-col-sm-${props.showdetails === "location" ? "12" : "6"} orm-mb-16 orm-mb-sm-0`}
                >
                  <div>{station.street}</div>
                  <div>
                    {station.zipcode} {station.city}
                  </div>
                  <div className="orm-mt-16">
                    <i className="fas fa-phone"></i> {station.phone}
                  </div>
                  <div>
                    <i className="fas fa-envelope"></i>
                    <a
                      className="orm-stations__mail"
                      href={`mailto:${station.email}`}
                    >
                      {station.email}
                    </a>
                  </div>

                  {props.detailpage === "true" ? (
                    <div className="hide-mobile-only">
                      <a
                        href={
                          ORMfunctions.baseLang() +
                          `/station/` +
                          slug(station.name)
                        }
                        className="orm-button__cta small orm-mt-24"
                      >
                        {ORMfunctions.i18n("general/linktostation") ||
                          "Zur Station"}
                      </a>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {(props.showdetails === "all" ||
                props.showdetails === "openingtimes") && (
                <div className="orm-col-xs-12 orm-col-sm-6">
                  <div>
                    {station.opentimes.map((opentime: any) => (
                      <div
                        className="orm-row"
                        key={opentime.id || opentime.day_of_week}
                      >
                        <div className="orm-col-xs-2">
                          {ORMfunctions.i18n(
                            "Wochentage_kurz/" + opentime.day_of_week,
                            true,
                          )}
                        </div>
                        <div className="orm-col-xs-8">
                          {opentime.times.length > 0 &&
                            opentime.times.map(
                              (time: any, timeIndex: number) => (
                                <div
                                  key={`${opentime.day_of_week}-${timeIndex}`}
                                >
                                  {time}{" "}
                                  {ORMfunctions.i18n("general/hour") || "Uhr"}
                                </div>
                              ),
                            )}
                          {opentime.times.length <= 0 &&
                            (ORMfunctions.i18n("general/closed") ||
                              "geschlossen")}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {props.detailpage === "true" ? (
                <div className="orm-col-xs-12 show-mobile-only orm-mt-16">
                  <a
                    href={
                      ORMfunctions.baseLang() + `/station/` + slug(station.name)
                    }
                    className="orm-button__cta orm-btn__block text-center"
                  >
                    {ORMfunctions.i18n("general/linktostation") ||
                      "Zur Station"}
                  </a>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <li className="orm-col-xs-12 orm-col-md-4 orm-col-lg-3">
        <a
          className="orm-stationlist-textlink"
          href={ORMfunctions.baseLang() + `/station/` + slug(station.name)}
        >
          <span>{station.name}</span>
        </a>
      </li>
    );
  }
}

export default StationDetail;
